import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { AnimationCrossfade } from '@ui/components/AnimationCrossfade';
import { PageTabs, PageTabsTab } from '@ui/components/PageTabs';
import { HorizontalScroll } from '@ui/components/HorizontalScroll';

import { ClubParticipantsFormWidget } from '@features/club/ui/ClubParticipantsForm/ClubParticipantsFormWidget';
import { ClubInfoFormWidget } from '@features/club/ui/ClubInfoForm/ClubInfoFormWidget';
import { ClubNewsListEditWidget } from '@features/club/ui/ClubNewsListEdit/ClubNewsListEditWidget';
import { SimpleSubHeader } from '@features/shared/ui/SimpleSubHeader';
import { ClubAdminWidget } from '@features/club/ui/ClubAdmin';

export type PageTab = 'participants' | 'club' | 'news' | 'admin';

export type Props = {
  clubId: string;
  tabs: PageTabsTab<PageTab>[];
  tab: PageTab;
  onTabChange: (newTab: PageTab) => void;
};

export function ClubSettingsPage({ clubId, tabs, tab, onTabChange }: Props) {
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate({ to: '/club/$clubId', params: { clubId } });
  }, [navigate, clubId]);

  return (
    <>
      <SimpleSubHeader title="Настройки" onBack={goBack} />

      <HorizontalScroll
        scrollToSelector={`#tab-${tab}`}
        scrollToSelectorBlock="center"
      >
        <PageTabs tabs={tabs} value={tab} onChange={onTabChange} />
      </HorizontalScroll>

      <AnimationCrossfade contentKey={tab}>
        {tab === 'participants' && <ClubParticipantsFormWidget clubId={clubId} />}
        {tab === 'club' && <ClubInfoFormWidget clubId={clubId} />}
        {tab === 'news' && <ClubNewsListEditWidget clubId={clubId} />}
        {tab === 'admin' && <ClubAdminWidget clubId={clubId} />}
      </AnimationCrossfade>
    </>
  );
}
